const initializeCampaignIdHelper = () => {
  const params = new URLSearchParams(window.location.search);

  const campaignId =
    params.get('salesforce_campaign_id') ||
    params.get('salesforce campaign id') ||
    params.get('campaign') ||
    params.get('campaign_id') ||
    params.get('utm_campaign') ||
    params.get('int_cmpgn') ||
    '';
  const campaignIdFields = document.querySelectorAll(
    "input[name='campaign_id']"
  );

  campaignIdFields.forEach((field) => {
    field.value = campaignId;
  });
};

export { initializeCampaignIdHelper };
